import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, makeStyles } from '@material-ui/core';
import cx from 'classnames';
import { alpha } from '@material-ui/core/styles';
import { MenuItem } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  error: {
    color: theme.palette.error.main,
  },
  container: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
  },
  icon: {
    width: 16,
    height: 16,
    display: 'flex',
    alignItems: 'center',
  },
  disabledIcon: {
    opacity: .2,
  },
  topDriver: {
    borderTop: `1px solid ${alpha(theme.palette.text.secondary, .2)}`,
    borderRadius: 0,
  },
  hideLoading: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0,
    backgroundColor: 'white',
    transition: 'opacity 0.6s linear',
  },
  showLoading: {
    opacity: 1,
    transition: 'opacity 0.6s linear',
  }
}));

function CustomMenuItem({
                          title,
                          onClick,
                          setAnchorEl,
                          icon,
                          isErrorStyle,
                          hasTopDriver,
                          isDisabled,
                          rowUuid,
                          showConditionFlag,
                          showConditionValue,
                          isLoading,
                        }) {
  const classes = useStyles();
  const disabled = useMemo(
    () => (isDisabled && isDisabled(rowUuid)),
    [rowUuid],
  );
  const showAction = showConditionFlag === showConditionValue;

  return (showAction ? <MenuItem
    key={title}
    disabled={disabled}
    onClick={(event) => {
      event.preventDefault();
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
      onClick(event);
      setAnchorEl(null);
    }} className={cx({
    [classes.topDriver]: hasTopDriver,
  })}>
    <div className={cx(classes.container, {
      [classes.error]: isErrorStyle,
    })}>
      <div className={cx(classes.icon, {
        [classes.disabledIcon]: disabled,
      })}>
        {icon}
      </div>
      {title}
      <div className={cx(classes.hideLoading, {
        [classes.showLoading]: isLoading,
      })}>
        <CircularProgress
          color={'primary'}
          size={20}
        />
      </div>
    </div>
  </MenuItem> : <></>);

}

CustomMenuItem.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.any,
  isErrorStyle: PropTypes.bool,
  hasTopDriver: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

export default CustomMenuItem;
